import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { FormControl, MenuItem, Select as MuiSelect } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
export { NativeSelect } from '@material-ui/core';
export const BaseSelect = (_a) => {
    var { options, children } = _a, props = __rest(_a, ["options", "children"]);
    return (_jsx(MuiSelect, Object.assign({}, props, { children: options
            ? options.map((option) => (_jsx(MenuItem, Object.assign({ value: option.value }, { children: option.label }), option.value)))
            : children }), void 0));
};
const useStyles = makeStyles((theme) => ({
    selectRoot: {
        paddingTop: theme.typography.pxToRem(10),
        paddingBottom: theme.typography.pxToRem(10),
        width: '100%',
        fontSize: theme.typography.pxToRem(14),
    },
    menuItem: {
        fontSize: theme.typography.pxToRem(14),
    },
}));
export const Select = (_a) => {
    var { options, fullWidth = false } = _a, selectProps = __rest(_a, ["options", "fullWidth"]);
    const classes = useStyles();
    return (_jsx(FormControl, Object.assign({ variant: "outlined", fullWidth: fullWidth }, { children: _jsx(MuiSelect, Object.assign({ classes: {
                root: classes.selectRoot,
            } }, selectProps, { children: options.map((option) => (_jsx(MenuItem, Object.assign({ value: option.value, className: classes.menuItem }, { children: option.label }), option.value))) }), void 0) }), void 0));
};
//# sourceMappingURL=Select.js.map